import { html } from 'lit';
import { Copy } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-copy')
export class PdsIconCopy extends PdsIcon {
  @state()
  icon = Copy;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
